import { CHEMKIT_HOST_INFLIGHT_MS } from './config';

export function createSaveExecutor({
  hostAdapter,
  toPaneKey,
  getAllTabs,
}) {
  const inFlight = new Map();
  const log = (...args) => hostAdapter.logAutosave(...args);

  const saveTab = (key, options = {}) => {
    log('saveTab:start', { key });
    if (!key) {
      log('saveTab:skip', { key: '', reason: 'not-found' });
      return { ok: false, key: '', reason: 'not-found' };
    }

    const panes = getAllTabs();
    const pane = panes.find((candidate) => candidate.key === key);

    if (!pane) {
      log('saveTab:skip', { key, reason: 'not-found' });
      return { ok: false, key, reason: 'not-found' };
    }

    if (!pane.isDirty) {
      log('saveTab:skip', { key, reason: 'not-dirty' });
      return { ok: false, key, reason: 'not-dirty' };
    }

    if (!pane.canSave) {
      log('saveTab:skip', { key, reason: 'save-disabled' });
      return { ok: false, key, reason: 'save-disabled' };
    }

    const now = Date.now();
    const inFlightUntil = inFlight.get(key) || 0;
    if (inFlightUntil > now) {
      log('saveTab:skip', { key, reason: 'in-flight' });
      return { ok: false, key, reason: 'in-flight' };
    }

    const { selecteds = [] } = hostAdapter.readTabsState();
    const target = selecteds.find((entry) => !Array.isArray(entry) && toPaneKey(entry) === key);

    if (!target) {
      log('saveTab:skip', { key, reason: 'not-found' });
      return { ok: false, key, reason: 'not-found' };
    }

    try {
      inFlight.set(key, now + CHEMKIT_HOST_INFLIGHT_MS);

      if (target.type !== 'reaction' && target.type !== 'sample') {
        log('saveTab:skip', { key, reason: 'unsupported-type', type: target.type });
        return { ok: false, key, reason: 'unsupported-type' };
      }

      if (target.type === 'reaction') {
        if (target.isNew) {
          log('saveTab:skip', { key, reason: 'save-disabled', type: target.type, isNew: true });
          return { ok: false, key, reason: 'save-disabled' };
        }

        hostAdapter.queueReactionSave(target, {
          background: options.background === true,
          trigger: options.source,
        });
        log('saveTab:queued', { key, type: target.type });
        return { ok: true, key, status: 'queued' };
      }

      if (target.isNew) {
        log('saveTab:skip', { key, reason: 'save-disabled', type: target.type, isNew: true });
        return { ok: false, key, reason: 'save-disabled' };
      }

      hostAdapter.queueSampleSave(target, {
        background: options.background === true,
        trigger: options.source,
      });
      log('saveTab:queued', { key, type: target.type });
      return { ok: true, key, status: 'queued' };
    } catch (error) {
      log('saveTab:error', {
        key,
        reason: 'error',
        message: error instanceof Error ? error.message : String(error),
      });
      return {
        ok: false,
        key,
        reason: 'error',
        message: error instanceof Error ? error.message : String(error),
      };
    }
  };

  return {
    saveTab,
  };
}
